import { PaymentAccountTransferMethod } from '@graphql/react-apollo'
import type { BankAccountFragmentFragment } from '@graphql/react-apollo'

import {
  isLinked,
  matchesMethod,
} from '@web-app/components/payment-account-management/lib/accountMatching'

const isCard = (account: BankAccountFragmentFragment): boolean =>
  matchesMethod(account, PaymentAccountTransferMethod.Card)

// A currently-usable debit card: a LINKED card. Unlike the bank step there's no
// "assign to application" — cards aren't attached to anything, so a usable card
// IS complete.
// NOTE: health (EXPIRED / INOP) could tighten this later if needed.
export function isUsableCard(account: BankAccountFragmentFragment): boolean {
  return isCard(account) && isLinked(account)
}

// A previously-linked card the user can re-activate via relinkPaymentAccount.
// Excludes the currently-linked card (which can also be `relinkable: true`) so
// this stays mutually exclusive with isUsableCard, regardless of resolve order.
export function isRelinkableCard(account: BankAccountFragmentFragment): boolean {
  return isCard(account) && account.relinkable && !isLinked(account)
}
